import { API_BASE_URL, API_PATHS,  } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class RegisterService {


    static userRegister(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.userRegister}`;
        return axiosInstance
            .post(api, data)

    }

       static uploadAadhaar(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.uploadAadhaar}`;
        return axiosInstance
            .post(api, data)

    }

  


}

export default RegisterService;
